export default {
  提交成功: 'Submission successful',
  数据保存中: 'Data is being saved',
  是必填项: 'Is a required field',
  添加客户关键联系人: 'Add key customer contact',
  编辑客户关键联系人: 'Edit key customer contact',
  删除该联系人: 'Delete this contact',
  请确认是否删除: 'Please confirm whether to delete',
  这条客户关键联系人: 'This key customer contact',
  获取数据失败: 'Failed to obtain data',
  基本特征: 'Basic features',
  修改: 'Modify',
  使用情况: 'Usage',
  查找数据: 'Search data',
  数据日期: 'Date of data',
  人均使用时长情况: 'Average usage duration',
  人均活跃情况: 'Average activeness',
  CCM渗透情况: 'CCM penetration',
  审批渗透情况: 'Approval penetration',
  日历渗透情况: 'Calendar penetration',
  IM渗透情况: 'IM penetration',
  打卡渗透情况: 'Clock-in penetration',
  音视频会议渗透情况: 'Audio and video meeting penetration',
  编辑动态记录: 'Edit follow-up record',
  外部: 'External',
  我方参会人: 'Our participants',
  客户参会人: 'Customer participants',
  妙记链接: 'mioji link',
  查看: 'View',
  跟进详情: 'Follow-up details',
  取消: 'Cancel',
  评论: 'Comment',
  暂无沟通记录: 'No communication records',
  回复: 'Reply',
  添加跟进: 'Add a follow-up',
  编辑跟进: 'Edit follow-up',
  请输入评论内容: 'Please enter a comment',
  展开更多: 'Expand more',
  折叠收起: 'Collapse',
  收起: 'Retract',
  展开: 'Expand',
  暂无此售后服务查看权限: 'No permission to view this after-sales service',
  客户特征: 'Customer features',
  客户关键联系人: 'Key customer contacts',
  '客户伙伴数据(天维度)': 'Customer partner data (day dimension)',
  商机: 'Business Opportunity',
  资料沉淀: 'Information deposition',
  姓名: 'Name',
  对接产品线: 'Docking product line',
  对接人角色: 'Docking role',
  对接人职位: 'Docking position',
  所在部门: 'Department',
  对接人态度: 'Docking attitude',
  联系方式: 'Contact method',
  补充信息: 'Additional information',
  编辑客户特征: 'Edit customer features',
  跟进时间: 'Follow-up time',
  跟进类型: 'Follow-up type',
  转移负责人: 'Transfer the person in charge'
};
